module.exports = __webpack_public_path__ + "static/media/coffeeshop.a399c323.JPG";